import React from 'react';

import useUserHook from 'hooks/useUserHook';

import classes from './homeHeader.module.scss';

export const HomeHeader = () => {
    const { firstName } = useUserHook();
    return <div className={classes.headline}>{`Hello ${firstName}`}</div>;
};
